export enum FecThirdPartyRole {
  Client = 'customer',
  Supplier = 'supplier',
}
